import _ from 'lodash';
import { createSelector } from 'reselect';

const organizationSelector = state => state.organization;

const localizationsSelector = (organization) => {

  const organizationData = organization.data || {};

  const organizationLocalizations = organizationData.localizations || {};
  
  return organizationLocalizations;
}

export default createSelector(
  organizationSelector,
  localizationsSelector
)



// WEBPACK FOOTER //
// ./src/selectors/localizationsSelector.js